import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'
import 'firebase/functions'
import 'firebase/storage'
import { firebaseConfig } from '../config/firebase-config'

firebase.initializeApp(firebaseConfig)

// To apply the default browser preference instead of explicitly setting it.
firebase.auth().useDeviceLanguage()

// Make data availale offline (default cache threshold is 40MB)
// More info: https://firebase.google.com/docs/firestore/manage-data/enable-offline
// firebase.firestore().enablePersistence()

export const firebaseAuth = firebase.auth
export const firebaseDb = firebase.firestore()
export const firebaseFuncs = firebase.app().functions('asia-east2')
export const firebaseStorage = firebase.storage()
